/**
 * 生成随机字符串
 * @returns
 */
export default function generateRandomHash() {
  return Math.random().toString(36).substring(2)
}
